import { render, staticRenderFns } from "./foodicsPay.vue?vue&type=template&id=d977efa2&scoped=true"
import script from "./foodicsPay.vue?vue&type=script&lang=ts"
export * from "./foodicsPay.vue?vue&type=script&lang=ts"
import style0 from "./foodicsPay.vue?vue&type=style&index=0&id=d977efa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d977efa2",
  null
  
)

export default component.exports